import { render } from "./ViewQuestionPage.vue?vue&type=template&id=4f53b764&ts=true"
import script from "./ViewQuestionPage.vue?vue&type=script&lang=ts"
export * from "./ViewQuestionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__